export default "__VITE_ASSET__DHd$Miya__"